<template>
  <div class="wizard" ref="wizard">
    <div :class="['wizard-tabs', theme]">
      <ul class="nav wizard-steps">
        <li class="nav-item" v-for="(tab, index) in tabs" :key="tab.title">
          <a data-toggle="tab" class="nav-link text-left pl-3" :class="[ index == currentIndex ? 'active' : '', index < currentIndex ? 'wizard-highlight' : '']" v-bind:href="'#wizard-' + (index+1)" @click="tabClicked(tab, index, $event)">
            <span class="float-right label label-danger" style="margin-top: 4px" v-if="errorCounts[index] > 0">{{errorCounts[index]}}</span>
            <span class="badge">{{index + 1}}</span>{{tab.title}}
            <span v-if="resultCounts[index] > 0" :class="['float-right', index <= currentIndex ? '' : 'text-success']">&nbsp;&nbsp;&nbsp;<i class="far fa-check-circle"></i>{{resultCounts[index]}}</span>
            <span v-if="warningCounts[index] > 0" :class="['float-right', index <= currentIndex ? '' : 'text-warning']">&nbsp;&nbsp;&nbsp;<i class="fas fa-exclamation-triangle"></i>{{warningCounts[index]}}</span>
          </a>
        </li>
      </ul>
    </div>
    <div class="wizard-content tab-content" ref="steps">
      <slot name="content" />
    </div>
    <hr v-if="showFooter" />
    <div class="wizard-actions clearfix" v-if="showFooter">
      <ul role="menu" aria-label="Pagination">
        <slot name="finish-button-list" v-if="displayFinish" />

        <FormWizardButton :disabled="!displayPrevious" @click="previousClicked">Previous</FormWizardButton>
        <FormWizardButton v-if="displayNext" @click="nextClicked">Next</FormWizardButton>

        <FormWizardButton v-if="displayFinish && showFinishButton" :loading="submitting" :disabled="finishDisabled" @click="finishClicked">{{finishTitle}}</FormWizardButton>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "FormWizard",
  props: {
    form: Object,
    tabList: Array,
    theme: {
      type: String,
      default: 'wizard-theme-default'
    },
    submitting: {
      type: Boolean,
      default: false
    },
    finishDisabled: {
      type: Boolean,
      default: false
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    showFinishButton: {
      type: Boolean,
      default: true
    },
    finishTitle: {
      type: String,
      default: 'Finish'
    },
  },
  data() {
    return {
      currentIndex: 0,
      tabs: this.tabList,
      errorCounts: [],
      warningCounts: [],
      resultCounts: []
    }
  },
  watch: {
    'tabList': { 
      handler: function(newItem) {
        this.tabs = newItem
      },
      deep: true
    }
  },
  computed: {
    displayPrevious() {
      return this.currentIndex > 0
    },
    displayNext() {
      return (this.currentIndex < this.tabs.length-1)
    },
    displayFinish() {
      return (this.currentIndex == this.tabs.length-1)
    },
  },
  methods: {
    // TODO: Badge with error count in tab?? Easier than changing pages

    previousClicked() { 
      if(this.currentIndex > 0) {
        this.currentIndex--
        this.updatePanel()
        this.$emit('stepChange', this.currentIndex)
      }
    },
    nextClicked() {
      if(this.currentIndex < this.tabs.length-1) {
        this.currentIndex++
        this.updatePanel()
        this.$emit('stepChange', this.currentIndex)
      }
    },
    finishClicked() {
      this.$emit('finished')
    },
    tabClicked(tabItem, tabIndex, evt) {
      this.selectTab(tabIndex)
    },
    selectTab(tabIndex) {
      if(tabIndex >= 0 && tabIndex <= this.tabs.length-1) {
        this.currentIndex = tabIndex
        this.updatePanel()
        this.$emit('stepChange', this.currentIndex)
      }
    },
    updatePanel() {
      for(var i=0; i<this.tabs.length; i++) {
        if(i == this.currentIndex)
          $(this.$refs.steps.children[i]).addClass('active')
        else
          $(this.$refs.steps.children[i]).removeClass('active')
      }
    },
    displayErrors() {
      this.$nextTick(() => {
        try {
          var errorInputList = $(this.$refs.wizard).find('.is-invalid')

          var tabUpdateList = this.tabs
          this.errorCounts = this.tabs.map((x) => { return 0 })

          $.each(errorInputList, (index, el) => {
            var pageList = $(el).parents('.wizard-page')
            if(pageList.length > 0) {
              let pageIndex = $(pageList[0]).data('page-index')-1
              let pageStepId = $(pageList[0]).data('page-stepid')

              if(pageIndex == -1 && pageStepId)
                pageIndex = tabUpdateList.findIndex(tab => pageStepId == tab.id)

              if(pageIndex >= 0 && pageIndex < tabUpdateList.length-1) {
                this.errorCounts[pageIndex]++
              }
            }
          })

          // Scroll to the top of the page to show the error
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
          })

        } catch { }
      })
    },
    clearWarningCounts() {
      this.warningCount = []
    },
    setWarningCount(tabIndex, count) {
      this.$nextTick(() => {
        // Refresh list to match tabs
        this.warningCounts = this.tabs.map((x, index) => {
          if(this.warningCounts && this.warningCounts.length > index)
            return this.warningCounts[index]
          return 0
        })
        this.warningCounts[tabIndex] = count
      })
    },
    clearResultCounts() {
      this.resultCounts = []
    },
    setResultCount(tabIndex, count) {
      this.$nextTick(() => {
        // Refresh list to match tabs
        this.resultCounts = this.tabs.map((x, index) => {
          if(this.resultCounts && this.warningCounts.length > index)
            return this.resultCounts[index]
          return 0
        })
        this.resultCounts[tabIndex] = count
      })
    },
  },
  mounted() {
    this.updatePanel()
    
  }
};
</script>